import { shouldPollUpload, useSocialUploadPolling } from '@app/modules/social-export/publish';
import { CompositionSocialUploadItemDto } from '@app/modules/compose/composition.types';
import { ComposeSocialExportUploadItemCard } from './ComposeSocialExportUploadItemCard';

interface ComposeSocialExportUploadItemProps {
  upload: CompositionSocialUploadItemDto;
}

/**
 * Single composition social upload row: polls while pending, then renders the card.
 */
export function ComposeSocialExportUploadItem({
  upload: initialUpload,
}: ComposeSocialExportUploadItemProps) {
  const shouldPoll = shouldPollUpload(initialUpload);

  const polledQuery = useSocialUploadPolling(initialUpload.id, {
    enabled: shouldPoll,
  });

  const upload = shouldPoll
    ? ((polledQuery.data ?? initialUpload) as CompositionSocialUploadItemDto)
    : initialUpload;

  return <ComposeSocialExportUploadItemCard upload={upload} />;
}
